import { forwardRef } from 'react';

import { PhoneInput } from '../../inputs/PhoneInput/PhoneInput';
import { DefaultFormFieldLayout } from '../DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '../FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldPhoneProps = {
  inputProps?: {
    id?: string;
    name?: string;
  };
  label?: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: HelperText;
  inline?: boolean;
  placeholder?: string;
  disabled?: boolean;
};

export const CoreFormFieldPhone = forwardRef(function _CoreFormFieldPhone(
  {
    inputProps,
    label,
    value,
    onChange,
    error,
    helperText,
    inline,
    disabled,
    placeholder,
  }: CoreFormFieldPhoneProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      error={error}
      inputId={inputProps?.id}
      inline={inline}
      helperText={helperText}
    >
      <PhoneInput
        ref={ref}
        id={inputProps?.id}
        value={value}
        onChange={onChange}
        error={error}
        dataTestId={inputProps?.id}
        disabled={disabled}
        placeholder={placeholder}
      />
    </DefaultFormFieldLayout>
  );
});
